import { render, staticRenderFns } from "./UserInputButton.vue?vue&type=template&id=8f9cb96a&scoped=true"
import script from "./UserInputButton.vue?vue&type=script&lang=js"
export * from "./UserInputButton.vue?vue&type=script&lang=js"
import style0 from "./UserInputButton.vue?vue&type=style&index=0&id=8f9cb96a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f9cb96a",
  null
  
)

export default component.exports